import { useState } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import EditWorkflowNameAndDescriptionModal from 'automation-ui-management/components/WorkflowNameWithDescription/EditWorkflowNameAndDescriptionModal';
import DescriptionsTooltip from 'automation-ui-management/components/WorkflowNameWithDescription/DescriptionsTooltip';
import { useGetNameAndDescription } from 'automation-ui-management/components/WorkflowNameWithDescription/nameAndDescriptionHooks';
import { EditIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WorkflowNameWithDescription = ({
  flow: flowFromProps,
  flowId,
  hasDescriptionTooltip,
  hideDescriptionTooltipWhenEmpty,
  onDescriptionSaveSuccess,
  onHybridNameSaveSuccess,
  readOnly,
  title,
  use = 'on-dark'
}) => {
  const {
    flow,
    description,
    getFlowQueryResult,
    getCrmObjectResult,
    shouldPollForDescription
  } = useGetNameAndDescription({
    flowId,
    flowFromProps
  });
  const trackEvent = useTrackEvent();
  const buttonText = flow ? title || flow.name : null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isEditable = !readOnly && !shouldPollForDescription && flow;
  const shouldHideHelpToolTip = !!hideDescriptionTooltipWhenEmpty && !description;

  // DEV NOTE: three different conditions can cause the tooltip disabled/hidden:
  // 1 - The hideDescriptionTooltipWhenEmpty prop is true and there is not a description
  // 2 - The hasDescriptionTooltip prop is set to false
  // 3 - shouldPollForDescription from useGetNameAndDescription hook is set to true,
  //     this is the case when there is not a description and the hasDescription query param is set to true
  const tooltipDisabled = shouldHideHelpToolTip || !hasDescriptionTooltip || shouldPollForDescription;
  const flowType = getIn(['data', 'automation_ui_index_crmObjectSearch', 'properties', 'hs_flow_type', 'value'], getCrmObjectResult);
  const renderWorkflowNameButton = () => {
    return /*#__PURE__*/_jsx(DescriptionsTooltip, {
      description: description,
      disabled: tooltipDisabled,
      flowType: flowType,
      children: /*#__PURE__*/_jsx(Clickable, {
        onClick: () => {
          trackEvent(Trackables.CLICK_EDIT_WORKFLOW_NAME_AND_DESCRIPTION);
          setIsModalOpen(true);
        },
        disabled: !isEditable,
        children: getFlowQueryResult.loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
          size: "extra-small",
          layout: "centered"
        }) : /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(View, {
            maxInlineSize: "600px",
            children: /*#__PURE__*/_jsx(Text, {
              typography: "heading-200",
              use: use,
              truncate: true,
              children: buttonText
            })
          }), isEditable && /*#__PURE__*/_jsx(IconHolder, {
            icon: EditIcon,
            marginInlineStart: "200",
            marginInlineEnd: "400",
            size: "300",
            color: use === 'on-dark' ? 'icon-interactive-on-fill-default' : 'icon-interactive-default'
          })]
        })
      })
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderWorkflowNameButton(), isModalOpen && /*#__PURE__*/_jsx(EditWorkflowNameAndDescriptionModal, {
      flow: flow,
      flowId: flowId,
      onClose: () => setIsModalOpen(false),
      onDescriptionSaveSuccess: onDescriptionSaveSuccess,
      onNameSaveSuccess: onHybridNameSaveSuccess,
      readOnly: readOnly
    })]
  });
};
export default WorkflowNameWithDescription;